import { useState } from "react";
import { useDropzone } from "react-dropzone";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";

import "react-quill/dist/quill.snow.css";

import { EditorState, } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

import SaveAltOutlinedIcon from "@mui/icons-material/SaveAltOutlined";
import PreviewOutlinedIcon from "@mui/icons-material/PreviewOutlined";
import UploadOutlinedIcon from "@mui/icons-material/UploadOutlined";
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';

const NewArticle = () => {
  const [uploadedImage, setUploadedImage] = useState(null);

  const [editorState, setEditorState] = useState(() =>
    EditorState.createEmpty()
  );

  const handleEditorChange = (newEditorState) => {
    setEditorState(newEditorState);
  };

  const handleFileUpload = (acceptedFiles) => {
    const file = acceptedFiles[0];
    setUploadedImage(URL.createObjectURL(file));
  };

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: handleFileUpload,
  });

  return (
    <Grid container spacing={2} className="mt-3">
      <Grid item xs={8} className="AddArticle--Left">
        <div>
          <p>Article Title</p>
          <TextField id="outlined-basic" variant="outlined" />
        </div>

        <div>
          <p>Post Content</p>
          <Editor
            editorState={editorState}
            onEditorStateChange={handleEditorChange}
          />
        </div>
      </Grid>

      <Grid item xs={4} className="AddArticle--Right">
        <div className="bg-white rounded-4 padding-3">
          <h6>Post Setting</h6>
          <div className="d-flex align-items-center gap-2 ArticleActions--Container">
            <Button>
              <SaveAltOutlinedIcon />
              Save
            </Button>

            <Button>
              <PreviewOutlinedIcon />
              Preview
            </Button>

            <Button className="PublishButton">
              <UploadOutlinedIcon />
              Publish
            </Button>
          </div>

          <p>Thumbnail Image</p>
          <div {...getRootProps({className: 'dropzone'})}>
            <input {...getInputProps()} />
            {uploadedImage ? (
              <img src={uploadedImage} alt="Uploaded" />
            ) : (
              <div>
                <ImageOutlinedIcon />
                <p>Upload Image</p>
                <span>Suggested size 1270x600 </span>
              </div>
              
            )}
          </div>
        </div>
      </Grid>
    </Grid>
  );
};

export default NewArticle;
